import axios from "axios";
import { handleActions } from "redux-actions";

import Config from "config";
import { getHeaders } from "helpers/headers";
import { AnyAction } from "interfaces/action";
import { Dispatch } from "interfaces/dispatch";
import { ThunkActionCreator } from "interfaces/thunk";

export const FETCH_REVIEW_FEEDBACK_DASHBOARD_REQUEST = "FETCH_REVIEW_FEEDBACK_DASHBOARD_REQUEST";
export const FETCH_REVIEW_FEEDBACK_DASHBOARD = "FETCH_REVIEW_FEEDBACK_DASHBOARD";
export const FETCH_REVIEW_FEEDBACK_DASHBOARD_FAILED = "FETCH_REVIEW_FEEDBACK_DASHBOARD_FAILED";

export const fetchFeedbackReviewDashboard: ThunkActionCreator =
  (projectId: number | string) => (dispatch: Dispatch) => {
    dispatch({ type: FETCH_REVIEW_FEEDBACK_DASHBOARD_REQUEST });

    return axios
      .get(`${Config.API_SERVICE_URL}/api/dashboards/feedback-review/${projectId}`, getHeaders())
      .then((response) => {
        dispatch({
          type: FETCH_REVIEW_FEEDBACK_DASHBOARD,
          payload: response.data,
        });
      })
      .catch((error: Error) => dispatch({ type: FETCH_REVIEW_FEEDBACK_DASHBOARD_FAILED }));
  };

export interface FeedbackReviewDashboardData {
  data?: number[];
  labels?: string[];
  total?: number;
  colors?: string[];
}

export interface FeedbackReviewDashboardState {
  error: boolean;
  loading: boolean;
  content: FeedbackReviewDashboardData;
}

const initialState = {
  error: false,
  loading: false,
  content: {},
};

// Actions
const actions = {
  [FETCH_REVIEW_FEEDBACK_DASHBOARD_REQUEST]: (state: FeedbackReviewDashboardState) => ({
    ...state,
    loading: true,
  }),
  [FETCH_REVIEW_FEEDBACK_DASHBOARD]: (state: FeedbackReviewDashboardState, action: AnyAction) => ({
    ...state,
    loading: false,
    content: action.payload,
  }),
  [FETCH_REVIEW_FEEDBACK_DASHBOARD_FAILED]: (state: FeedbackReviewDashboardState) => ({
    loading: false,
    error: true,
    content: {},
  }),
};

export default handleActions<FeedbackReviewDashboardState, AnyAction>(actions, initialState);
